import { useState, useEffect } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { useTranslation } from "react-i18next";

const getTypeOptions = (t) => [
  { value: "all", label: t("All") },
  { value: "comment", label: t("Commentaire") },
  { value: "category", label: t("Category") },
  { value: "deletion", label: t("Deletion") },
];

const TypeFilterModalRevision = ({
  isOpen,
  onClose,
  onApply,
  currentTypeFilter,
}) => {
  const { t } = useTranslation();
  const [selectedType, setSelectedType] = useState(currentTypeFilter || "all");

  useEffect(() => {
    if (isOpen) {
      setSelectedType(currentTypeFilter || "all");
    }
  }, [isOpen, currentTypeFilter]);

  const handleTypeSelect = (typeValue) => {
    setSelectedType(typeValue);
  };

  const handleApply = () => {
    onApply(selectedType);
    onClose();
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={onClose}
      modalClassName="char-period-filter-modal"
      contentClassName="rounded-lg"
      style={{ maxWidth: "400px" }}
      centered
    >
      <ModalHeader className="char-modal-header">
        <span className="char-modal-header-title">{t("Type")}</span>
        <button
          type="button"
          onClick={onClose}
          className="char-modal-header-close"
          aria-label={t("Close")}
        >
          <i className="fas fa-times char-modal-header-close-icon" />
        </button>
      </ModalHeader>
      <ModalBody className="char-modal-body char-modal-body--filter">
        <div className="char-status-modal-list">
          {getTypeOptions(t).map((opt) => {
            const isSelected = selectedType === opt.value;
            return (
              <label
                key={opt.value}
                className="char-status-modal-checkbox"
                data-status={opt.value}
              >
                <input
                  type="checkbox"
                  checked={isSelected}
                  onChange={() => handleTypeSelect(opt.value)}
                  className="char-status-modal-checkbox-input"
                />
                <span className="char-status-modal-checkbox-label">
                  {opt.label}
                </span>
              </label>
            );
          })}
        </div>
      </ModalBody>
      <ModalFooter className="char-modal-footer">
        <button type="button" onClick={handleCancel} className="char-button">
          {t("Cancel")}
        </button>
        <button
          type="button"
          onClick={handleApply}
          className="char-button char-button-primary"
        >
          {t("Apply")}
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default TypeFilterModalRevision;
